import axiosInstance from "./api";

export const getProfile = async () => {
  const response = await axiosInstance.get("/profile/me");

  // Sync the latest isVerified status into localStorage
  const user = response.data?.user || response.data?.data;
  if (user && typeof user.isVerified !== "undefined") {
    localStorage.setItem("isVerified", String(user.isVerified));
  }

  return response.data;
};

// Update current user profile
export const updateProfile = async (profileData) => {
  const response = await axiosInstance.put("/profile/me", profileData);
  return response.data;
};

// Dismiss role review banner
export const dismissRoleReview = async () => {
  const response = await axiosInstance.put("/profile/me/dismiss-role-review");
  return response.data;
};

// Change password
export const changePassword = async (passwordData) => {
  const response = await axiosInstance.put(
    "/profile/change-password",
    passwordData,
  );
  return response.data;
};

// Delete account
export const deleteAccount = async (passwordData) => {
  const response = await axiosInstance.delete("/profile/me", {
    data: passwordData,
  });
  return response.data;
};

// Get user by ID (public)
export const getUserById = async (userId) => {
  const response = await axiosInstance.get(`/profile/user/${userId}`);
  return response.data;
};

// Get users by purpose (public)
export const getUsersByPurpose = async (purpose, params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const url = queryParams
    ? `/profile/users/${purpose}?${queryParams}`
    : `/profile/users/${purpose}`;
  const response = await axiosInstance.get(url);
  return response.data;
};

export const getAllOrganizers = async (page = 1, limit = 10) => {
  try {
    const { data } = await axiosInstance.get(
      `/portfolio/all?page=${page}&limit=${limit}`,
    );

    // Ensure the response has the expected structure
    console.log(data);
    return {
      portfolios: data.portfolios || [],
      pagination: {
        currentPage: data.pagination?.currentPage || page,
        totalPages: data.pagination?.totalPages || 1,
        totalItems: data.pagination?.totalItems || 0,
        hasNextPage: data.pagination?.hasNextPage || false,
        hasPrevPage: data.pagination?.hasPrevPage || false,
      },
    };
  } catch (error) {
    console.error("Error fetching organizers:", error);
    // Return safe default structure on error
    return {
      portfolios: [],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        hasNextPage: false,
        hasPrevPage: false,
      },
    };
  }
};

// Get all users (admin)
export const getAllUsers = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const url = queryParams
    ? `/profile/all-users?${queryParams}`
    : `/profile/all-users`;
  const response = await axiosInstance.get(url);
  return response.data;
};

// ===== LEGACY ENDPOINTS FOR BACKWARD COMPATIBILITY =====

// presigned url (for portfolio/image uploads)
export async function getPresignedUrl(fileName, fileType) {
  const params = new URLSearchParams({ fileName, fileType });
  const res = await axiosInstance.get(`/portfolio/presigned-url?${params}`);
  return res.data; // { uploadURL, fileURL, key }
}

export async function uploadReferenceImage(file) {
  const formData = new FormData();
  formData.append("file", file);
  console.log("FormData:", formData);
  console.log("FormData keys:", Array.from(formData.keys()));
  console.log(
    "Upload request URL:",
    `${axiosInstance.defaults.baseURL || ""}/upload`,
  );

  try {
    const res = await axiosInstance.post("/upload", formData);
    console.log("Upload API response:", res?.data);
    return res.data;
  } catch (error) {
    console.error("Upload API error:", error?.response?.data || error);
    console.error(
      "uploadReferenceImage error:",
      error?.response?.data || error,
    );
    throw (
      error?.response?.data || {
        message: error.message || "Failed to upload image",
      }
    );
  }
}

// Get all organizers (event managers/planners)
// export const getAllOrganizers = async (page = 1, limit = 10) => {
//   // Use the new getUsersByPurpose endpoint for planners
//   const data = await getUsersByPurpose('planner', { page, limit });
//   return {
//     portfolios: data.users,
//     pagination: data.pagination
//   };
// };

// Get all volunteers (hosts)
export const getAllVolunteers = async () => {
  const data = await getUsersByPurpose("host");
  return data.users;
};

// Get portfolio by ID
// export const getPortfolioById = async (id) => {
//   const response = await getUserById(id);
//   return response.user;
// };

export const getPortfolioById = async (id) => {
  const response = await axiosInstance.get(`/portfolio/${id}`);
  return response.data.portfolio;
};

// Get portfolio by userId
export const getPortfolioByUserId = async (userId) => {
  const response = await getUserById(userId);
  return response;
};

// Customer Profile (alias for main profile functions)
export const getCustomerProfile = async () => {
  return await getProfile();
};

export const updateCustomerProfile = async (profileData) => {
  return await updateProfile(profileData);
};

// Customer profile update with file support (FormData → /customer/profile with multer)
export const updateCustomerProfileForm = async (formData) => {
  const response = await axiosInstance.put("/customer/profile", formData);
  return response.data;
};

export const changeCustomerPassword = async (passwordData) => {
  return await changePassword(passwordData);
};

// Customer Billing & Tax Details
export const getCustomerBilling = async () => {
  const response = await axiosInstance.get("/customer/billing");
  return response.data;
};

export const updateCustomerBilling = async (billingData) => {
  const response = await axiosInstance.put("/customer/billing", billingData);
  return response.data;
};
